import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import queryString from 'query-string';

import { absolute } from '../../../components/AnimatedRoutes';
import { disconnect, getConnections } from '../../../../../ducks/user/connections';
import { isMobile } from '../../../../../mobile/helpers';
import ConnectionsList from './Connections';
import Content from '../../../components/Content';
import Flash from '../../../components/Flash';
import Header from '../../../components/Header';
import InfoBox from '../../../components/InfoBox';
import dhid from '../../../../../dhid';
import requireUser from '../../../../../components/requireUser';
import styles from '../settings.scss';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  connectionsLoading: PropTypes.bool,
  connectionsAttempt: PropTypes.bool,
  history: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
    stackPop: PropTypes.func.isRequired,
  }),
  connectionsError: PropTypes.oneOfType([
    PropTypes.shape({
      response: PropTypes.shape({}),
    }),
    PropTypes.bool,
  ]),
  location: PropTypes.shape({
    state: PropTypes.shape({
      referrer: PropTypes.string,
    }),
  }),
  connections: PropTypes.arrayOf(PropTypes.shape({
    provider: PropTypes.string,
  })),
};

class Connections extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const {
      dispatch, history, connectionsLoading, connectionsAttempt,
    } = this.props;

    // Parse query string
    if (history.location.search) {
      const parsed = queryString.parse(history.location.search);

      // Save the result from the add connection command and remove it from the current URL
      if (parsed.updated || parsed.error || parsed.success) {
        /* eslint-disable react/no-did-mount-set-state */
        this.setState({
          createConnectionResult: parsed,
        });
        /* eslint-enable react/no-did-mount-set-state */
        setTimeout(() => {
          this.setState({
            createConnectionResult: false,
          });
        }, 5000);
      }

      // Remove query string from url
      history.replace(history.location.pathname);
    }

    if (!connectionsLoading && !connectionsAttempt) {
      dispatch(getConnections());
    }
  }

  addConnection = (provider) => (() => {
    const url = `${dhid.getBaseUrl()}/connect/${provider}?return_path=${window.location.pathname}`;
    if (isMobile()) {
      window.open(url);
    } else {
      window.location.href = url;
    }
  })

  disconnect = (connection) => (() => {
    const { dispatch } = this.props;
    dispatch(disconnect(connection.id));
  })

  render() {
    const {
      createConnectionResult,
    } = this.state;
    const {
      history,
      connections,
      connectionsError,
    } = this.props;

    const availableConnections = connections && [
      'esl',
      // 'facebook',
      // 'google',
      // 'steam',
      'discord',
      'twitch',
      // 'twitter',
    ].filter((provider) => (
      !connections.some((connection) => connection.provider === provider)
    ));

    const createConnectionResultError = () => {
      if (createConnectionResult && createConnectionResult.error) {
        switch (createConnectionResult.error) {
          case 'already_used':
            return 'That account is already connected to another DreamHack Account';
          case 'declined':
            return 'The authorization was aborted';
          default:
            return `Failed to connect. The error message was: ${createConnectionResult.error}`;
        }
      }
      return undefined;
    };

    return (
      <>
        <Flash
          title="Whoops!"
          message={createConnectionResultError()}
          error
          persist
        />
        <Flash
          title="Whoops!"
          message={createConnectionResult && createConnectionResult.updated && 'You already have that account connected.'}
          error
          persist
        />
        <Flash
          title="Whoops!"
          message={connectionsError && connectionsError.message}
          error
          persist
        />
        <Flash
          title="Success!"
          message={createConnectionResult && createConnectionResult.success && 'Success, your account is now connected!'}
        />
        <Header
          onBack={() => history.stackPop()}
        >
          Linked accounts
        </Header>
        <Content>
          <InfoBox>
            { connections && connections.length ? 'You have authorized us to use profile data from the following accounts.'
              : 'You haven\'t authorized us to use data from any account yet.' }
          </InfoBox>
          <div className={styles.panel}>
            { connections
              && (
              <ConnectionsList
                connections={connections}
                availableConnections={availableConnections}
                onDisconnect={this.disconnect}
                onConnect={this.addConnection}
              />
              )}
          </div>
        </Content>
      </>
    );
  }
}

Connections.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    connections: state.getIn(['connections', 'data']),
    connectionsLoading: state.getIn(['connections', 'loading']),
    connectionsError: state.getIn(['connections', 'error']),
    connectionsAttempt: state.getIn(['connections', 'attempt']),
  };
}

export default requireUser(connect(mapStateToProps)(absolute(Connections)));
